import Toastr from "../../../components/Toastr"
const DEFAULT_STATE = {
  social_history_sections: [],
  social_history_section: {},
  meta: {pagination: {}},
  saving: false,
  editing: false
}
let changes = null;
export default function socialHistorySectionReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  let socialHistorySections = [];
  let socialHistorySectionData = [];
  let updatedRecord = {};
  switch(action.type){
    case 'SOCIAL_HISTORY_SECTIONS_LOAD_PENDING':
    case 'SOCIAL_HISTORY_SECTION_LOAD_PENDING':
      return {...state, saving: true};

    case 'SOCIAL_HISTORY_SECTION_CREATE_PENDING':
      return {...state, saving: true};

    case 'SOCIAL_HISTORY_SECTIONS_LOAD_REJECTED':
    case 'SOCIAL_HISTORY_SECTION_LOAD_REJECTED':
    case 'SOCIAL_HISTORY_SECTION_CREATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case 'SOCIAL_HISTORY_SECTIONS_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      };
      return {...state, ...changes};
    
    case 'SOCIAL_HISTORY_SECTION_LOAD_FULFILLED':
      changes = {
        social_history_section: response.social_history_section,
        saving: false
      }
      return {...state,...changes};
    
    case 'SOCIAL_HISTORY_SECTION_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      socialHistorySections = [...state.social_history_sections]
      let newRecord = response.social_history_section
      changes = {
        social_history_sections: [...socialHistorySections, newRecord],
        saving: false
      }
      return {...state, ...changes};

    case 'SOCIAL_HISTORY_SECTION_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      socialHistorySections = [...state.social_history_sections];
      updatedRecord = response.social_history_section;
      for (const [index, socialHistorySection] of socialHistorySections.entries()) {
        if (socialHistorySection.id === updatedRecord.id) {
          socialHistorySectionData = [
            ...socialHistorySections.slice(0, index),
            updatedRecord,
            ...socialHistorySections.slice(index + 1)
          ];
        }
      }
      changes = {
        social_history_sections: socialHistorySectionData,
        social_history_section: {},
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case 'SOCIAL_HISTORY_SECTIONS_REORDER':
      changes = { social_history_sections: [...action.data] };
      return { ...state, ...changes };

    case 'SOCIAL_HISTORY_SECTION_EDIT':
      changes = {
        editing: {
          id: action.id,
        },
        social_history_section: {}
      };
      return { ...state, ...changes };

    case 'SOCIAL_HISTORY_SECTION_EDIT_CANCEL':
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}